module.exports = __webpack_public_path__ + "img/hero-vs_billymorgan.f6396c3.jpg";